<template>
  <main id="content" role="main">
    <!-- Hero Section -->
    <div class="gradient-x-overlay-sm-indigo position-relative overflow-hidden">
      <div class="container space-top-1">
        <div class="w-lg-60 text-center mx-lg-auto">
          <div class="mb-5">
            <h1 class="mb-3">MON COMPTE
            </h1>
            <p class="lead small">Bienvenue sur votre compte. Vous pouvez ici gérer vos informations personnelles et votre historique.

            </p>

            <!-- Features Section -->

            <!-- Nav -->
            <div class="text-center">
              <ul class="nav nav-segment nav-pills scrollbar-horizontal mb-7" role="tablist">
                <li class="nav-item">
                  <a class="nav-link active" id="pills-one-code-features-example1-tab" data-toggle="pill"
                     href="#pills-one-code-features-example1" role="tab" aria-controls="pills-one-code-features-example1"
                     aria-selected="true">Mes informations</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" id="pills-two-code-features-example1-tab" data-toggle="pill"
                     href="#pills-two-code-features-example1" role="tab" aria-controls="pills-two-code-features-example1"
                     aria-selected="false">Mes participations</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" id="pills-three-code-features-example1-tab" data-toggle="pill"
                     href="#pills-three-code-features-example1" role="tab" aria-controls="pills-three-code-features-example1"
                     aria-selected="false">Aide</a>
                </li>
              </ul>

              <!-- End Nav -->
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- End Hero Section -->



    <!-- Tab Content -->
    <div class="tab-content pr-lg-4">
      <div class="tab-pane fade show active" id="pills-one-code-features-example1" role="tabpanel" aria-labelledby="pills-one-code-features-example1-tab">
        <div class="container space-bottom-2">
          <div class="row mx-n2">
            <div class="col-sm-6 col-lg-3 px-2 mb-3">
              <!-- Icon Blocks -->
              <a class="card h-100 transition-3d-hover" href="/module/testmaquette/taxe_compte_prof">
                <div class="card-body">
                  <figure class="w-100 max-w-8rem mb-4">
                    <img class="img-fluid" src="/themes/template/img/icons/icon-9.svg" alt="SVG">
                  </figure>
                  <h4>Mes informations personnelles</h4>
                </div>
              </a>
              <!-- End Icon Blocks -->
            </div>

            <div class="col-sm-6 col-lg-3 px-2 mb-3">
              <!-- Icon Blocks -->
              <a class="card h-100 transition-3d-hover" href="#">
                <div class="card-body">
                  <figure class="w-100 max-w-8rem mb-4">
                    <img class="img-fluid" src="/themes/template/img/icons/icon-3.svg" alt="SVG">
                  </figure>
                  <h4>Paramètrage de la plateforme</h4>
                </div>
              </a>
              <!-- End Icon Blocks -->
            </div>

            <div class="col-sm-6 col-lg-3 px-2 mb-3">
              <!-- Icon Blocks -->
              <a class="card h-100 transition-3d-hover" href="#">
                <div class="card-body">
                  <figure class="w-100 max-w-8rem mb-4">
                    <img class="img-fluid" src="/themes/template/img/icons/icon-5.svg" alt="SVG">
                  </figure>
                  <h4>Ma e-carte</h4>
                </div>
              </a>
              <!-- End Icon Blocks -->


            </div>

            <div class="col-sm-6 col-lg-3 px-2 mb-3">
              <!-- Icon Blocks -->
              <a class="card h-100 transition-3d-hover" href="#">
                <div class="card-body">
                  <figure class="w-100 max-w-8rem mb-4">
                    <img class="img-fluid" src="/themes/template/img/icons/icon-2.svg" alt="SVG">
                  </figure>
                  <h4>Mes réservations</h4>
                </div>
              </a>
              <!-- End Icon Blocks -->
            </div>

            <div class="col-sm-6 col-lg-3 px-2 mb-3">
              <!-- Icon Blocks -->
              <a class="card h-100 transition-3d-hover" href="#">
                <div class="card-body">
                  <figure class="w-100 max-w-8rem mb-4">
                    <img class="img-fluid" src="/themes/template/img/icons/icon-2.svg" alt="SVG">
                  </figure>
                  <h4>Mes favoris</h4>
                </div>
              </a>
              <!-- End Icon Blocks -->
            </div>




          </div>
        </div>
      </div>

      <div class="tab-pane fade" id="pills-two-code-features-example1" role="tabpanel" aria-labelledby="pills-two-code-features-example1-tab">
        <div class="container space-bottom-2">
          <div class="row mx-n2">
            <div class="col-sm-6 col-lg-3 px-2 mb-3 mb-lg-0">
              <!-- Icon Blocks -->
              <a class="card h-100 transition-3d-hover" href="#">
                <div class="card-body">
                  <figure class="w-100 max-w-8rem mb-4">
                    <img class="img-fluid" src="/themes/template/img/icons/icon-9.svg" alt="SVG">
                  </figure>
                  <h4>Mes documents partagés</h4>
                </div>
              </a>
              <!-- End Icon Blocks -->
            </div>




            <div class="col-sm-6 col-lg-3 px-2">
              <!-- Icon Blocks -->
              <a class="card h-100 transition-3d-hover" href="/module/testmaquette/taxe_compte_prof">
                <div class="card-body">
                  <figure class="w-100 max-w-8rem mb-4">
                    <img class="img-fluid" src="/themes/template/img/icons/icon-2.svg" alt="SVG">
                  </figure>
                  <h4>Taxe d'apprentissage</h4>
                </div>
              </a>
              <!-- End Icon Blocks -->
            </div>



            <div class="col-sm-6 col-lg-3 px-2">
              <!-- Icon Blocks -->
              <a class="card h-100 transition-3d-hover" href="#">
                <div class="card-body">
                  <figure class="w-100 max-w-8rem mb-4">
                    <img class="img-fluid" src="/themes/template/img/icons/icon-2.svg" alt="SVG">
                  </figure>
                  <h4>Mes suggestions</h4>
                </div>
              </a>
              <!-- End Icon Blocks -->
            </div>




          </div>
        </div>
      </div>

      <div class="tab-pane fade" id="pills-three-code-features-example1" role="tabpanel" aria-labelledby="pills-three-code-features-example1-tab">
        <div class="container space-bottom-2">
          <div class="row mx-n2">

            <div class="col-sm-6 col-lg-3 px-2">
              <!-- Icon Blocks -->
              <a class="card h-100 transition-3d-hover" href="#">
                <div class="card-body">
                  <figure class="w-100 max-w-8rem mb-4">
                    <img class="img-fluid" src="/themes/template/img/icons/icon-2.svg" alt="SVG">
                  </figure>
                  <h4>Contacter le Support</h4>
                </div>
              </a>
              <!-- End Icon Blocks -->
            </div>

            <div class="col-sm-6 col-lg-3 px-2">
              <!-- Icon Blocks -->
              <a class="card h-100 transition-3d-hover" href="#">
                <div class="card-body">
                  <figure class="w-100 max-w-8rem mb-4">
                    <img class="img-fluid" src="/themes/template/img/icons/icon-2.svg" alt="SVG">
                  </figure>
                  <h4>Parrainer des utlisateurs</h4>
                </div>
              </a>
              <!-- End Icon Blocks -->
            </div>
          </div>
        </div>
        <!-- End Tab Content -->
      </div>
      <!-- End Features Section -->
    </div>
  </main>
</template>

<script>
export default {
  name: "DlnkTaxeAdminProf",

  watch: {

  },

  data: function () {
    return {

    }
  }
}
</script>

<style scoped>

</style>